// extracted by mini-css-extract-plugin
export default {"slider":"applications-components-ProductsApp-components-Sidebar-sidebar-module__slider","item":"applications-components-ProductsApp-components-Sidebar-sidebar-module__item","bar":"applications-components-ProductsApp-components-Sidebar-sidebar-module__bar","title":"applications-components-ProductsApp-components-Sidebar-sidebar-module__title"};
    if(module.hot) {
      // 1791528099525
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  